import * as L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

/**
 * 专属经济区区域图形展示类
 */
class ExclusiveEconomicZoneSymbol extends AreaViewBase {
  _show(): this {
    if (!this._data) {
      console.error('区域图形展示，请求无数据！')
      return this
    }

    const plackmarks = this._data.folder.plackmark
    let color = '#333'
    if ('MT_SATELLITE' === this._map.mapType) {
      color = '#fff'
    }

    for (const plackmark of plackmarks) {
      const name = plackmark.name
      const translatedName = !CanvasShipUtils.isEmpty(name)
        ? `专属经济区： ${name}`
        : name
      const polygons = plackmark.polygon

      for (const polygon of polygons) {
        const outerBoundaryIs = polygon.outerBoundaryIs
        const innerBoundaryIs = polygon.innerBoundaryIs

        if (outerBoundaryIs.length > 0) {
          this.drawBoundary(outerBoundaryIs, color, translatedName)
        }
        if (innerBoundaryIs.length > 0) {
          this.drawBoundary(innerBoundaryIs, '', translatedName)
        }
      }
    }

    return this
  }

  drawBoundary(boundarys: any[], borderColor: string, title: string): void {
    for (const boundary of boundarys) {
      const coordinates = boundary.coordinates.split(',')
      const latlngs: L.LatLngExpression[] = []
      const latlng360: L.LatLngExpression[] = []

      for (let j = 0; j < coordinates.length / 2; j++) {
        const lng = coordinates[2 * j]
        const lat = coordinates[2 * j + 1]
        latlngs.push(L.latLng(lat, lng))
        latlng360.push(L.latLng(lat, Number(lng) + 360))
      }

      if (latlngs.length > 0) {
        const polygon1 = L.polygon(latlngs, {
          color: borderColor,
          fillOpacity: 0.25,
          weight: 1,
          ...this.options,
        })

        const polygon2 = L.polygon(latlng360, {
          color: borderColor,
          fillOpacity: 0.25,
          weight: 1,
          ...this.options,
        })

        if (this.options.isShowName && title) {
          const getShowHtml = (): string => {
            return `
                <div class="title">${title}</div>
            `
          }

          const options: L.PopupOptions = {
            className: 'area-popup',
            closeButton: false,
          }

          polygon1
            .bindPopup(getShowHtml, options)
            .on('mousemove', (e) => {
              e.target.openPopup(e.latlng)
            })
            .on('mouseout', (e) => {
              e.target.closePopup()
            })

          polygon2
            .bindPopup(getShowHtml, options)
            .on('mousemove', (e) => {
              e.target.openPopup(e.latlng)
            })
            .on('mouseout', (e) => {
              e.target.closePopup()
            })

          polygon2.on('mouseover', (e) => {
            e.target.setStyle({
              fillColor: '#ff0000',
              fillOpacity: 0.2,
            })
          })
          polygon2.on('mouseout', (e) => {
            e.target.setStyle({
              fillColor: '#333',
              fillOpacity: 0.2,
            })
          })
          polygon1.on('mouseover', (e) => {
            e.target.setStyle({
              fillColor: '#ff0000',
              fillOpacity: 0.2,
            })
          })
          polygon1.on('mouseout', (e) => {
            e.target.setStyle({
              fillColor: '#333',
              fillOpacity: 0.2,
            })
          })

          polygon1.addTo(this._map)
          this._areaLayers.push(polygon1)
          polygon2.addTo(this._map)
          this._areaLayers.push(polygon2)
        }
      }
    }
  }
}

function exclusiveEconomicZoneSymbol(
  map: MyMap,
  options: Partial<AreaViewBaseOptions>
): ExclusiveEconomicZoneSymbol {
  return new ExclusiveEconomicZoneSymbol(map, options)
}

export { ExclusiveEconomicZoneSymbol, exclusiveEconomicZoneSymbol }
